export default {
    data: function () {
        return {};
    },
    methods: {
        onProductLoaded: function (productTitle) {
            this.sendGEvent('Product views', 'viewed', productTitle);
        },
        onProductAddedToCart: function (productTitle) {
            this.sendGEvent('Cart', 'product added', productTitle);
        },
        onProductRemovedFromCart: function (productTitle) {
            this.sendGEvent('Cart', 'product removed', productTitle);
        },
        onProductCountIncreased: function (productTitle) {
            this.sendGEvent('Cart', 'product count increased', productTitle);
        },
        onProductCountDecreased: function (productTitle) {
            this.sendGEvent('Cart', 'product count decreased', productTitle);
        },
        onCategoryLoaded: function (categoryTitle) {
            this.sendGEvent('Category views', 'category viewed', categoryTitle);
        },
        onCatalogLoaded: function (catalogTitle) {
            this.sendGEvent('Catalog views', 'catalog viewed', catalogTitle);
        },
        onFilterSelected: function (filter, catalogTitle) {
            this.sendGEvent('Filters selection', 'filter selected', `${filter} selected on ${catalogTitle}`);
        },
        onSignedIn: function (username) {
            this.sendGEvent('Login', 'user logged in', username);
        },
        onSignedUp: function (username) {
            this.sendGEvent('Login', 'user logged out', username);
        },
        onOrderCreated: function (number) {
            this.sendGEvent('Orders', 'order created', number);
        },
        sendGEvent: function (category, action, label) {
            try {
                if (typeof window.ga === undefined) {
                    console.log('Unable send event to GA');
                    return;
                }
                window.ga('send', 'event', category, action, label);
            } catch(ex) {
                console.log('[ga] unable send ga event');
            }
        },
    },
};
